import { render, staticRenderFns } from "./TgRelativeTime.vue?vue&type=template&id=b2978cf6"
import script from "./TgRelativeTime.vue?vue&type=script&lang=js"
export * from "./TgRelativeTime.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports